module.exports = __webpack_public_path__ + "static/media/10.6f1a80ec.svg";